module.exports = __webpack_public_path__ + "static/media/FACURRYL_MENU-normal.ea54e3d8.png";